import type { AbsenceStatus } from '@timetable/types';

export const ABSENCE_STATUS_CHIP_CONFIG: Record<
  AbsenceStatus,
  { label: string; color: 'default' | 'warning' | 'info' | 'success' | 'error' | 'primary' }
> = {
  pending:       { label: 'Needs Plan',  color: 'warning' },
  draft_pending: { label: 'Needs Plan',  color: 'warning' },
  active:        { label: 'In Progress', color: 'info'    },
  posted:        { label: 'Done',        color: 'success' },
  cancelled:     { label: 'Cancelled',   color: 'error'   },
};
